import "./cardColor.css";
import IconCheck from "../../../assets/svgs/check.svg";
interface CardPage {
  titleStatus: string | undefined;
  qtyCard: string;
  icon?: any;
  handleClick?: any;
  style?: any;
  ref?: any;
}

const CardDashboard = ({
  titleStatus,
  qtyCard,
  icon,
  handleClick,
  style,
  ref,
}: CardPage) => {
  return (
    <>
      <div className={`cardColors`} ref={ref}>
        <button
          type="button"
          className="iconExplain info-btn"
          onClick={handleClick}
          aria-label="Explicação"
        >
          <img src={icon} alt="" aria-hidden="true" />
        </button>
        <div className="iconCard">
          <img src={IconCheck} className="iconCheck" alt="" />
        </div>
        <div className="infoCard">
          <div className={`statusCurrentCard ${style}`}>
            <span>{titleStatus}</span>
          </div>
          <div className="statusQty">
            <span>{qtyCard}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardDashboard;
